var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotePencilRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.707 7.293l-4-4a1 1 0 00-1.415 0l-12 12A1 1 0 0011 16v4a1 1 0 001 1h4a1 1 0 00.707-.292l12-12a1 1 0 000-1.415zM15.588 19H13v-2.586l8-8L23.586 11l-8 8zM25 9.586L22.414 7 24 5.414 26.586 8 25 9.586zM28 15v11a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h11a1 1 0 110 2H6v20h20V15a1 1 0 012 0z"
  })));
}
export default SvgNotePencilRegular;